import _ from 'underscore';
import { useEffect, useContext, useState } from 'react';
import { getSDKParams, getLanguageFromMkt } from '@bingads-webui-campaign-react/sdk-utils';
import { PreferenceContext } from '@bingads-webui-react/preference-context';
import { usePreference, preferenceNames } from '@bingads-webui-campaign-react/pmax-lite-data';


export const useUpdatePreferencesFromURL = (afterResetPreferences) => {
  const preferenceService = useContext(PreferenceContext);
  const [{ value: websiteUrlPreference }, { update: updateWebsitePreference }] = usePreference(preferenceNames.WebsiteUrl);
  const [, { update: updateLanguagePreference }] = usePreference(preferenceNames.SelectedLanguage);
  const [, { update: updateCountryPreference }] = usePreference(preferenceNames.SelectedCountry);
  const [, { update: updateMktPrefillEnabledPreference }]
    = usePreference(preferenceNames.MarketPrefillEnabled);
  const { mkt, finalUrl, country } = getSDKParams();
  const language = getLanguageFromMkt(mkt);
  const [preferenceReady, setPreferenceReady] = useState(false);

  useEffect(() => {
    if (preferenceService && _.isFunction(preferenceService.setAtUserLevel) && !preferenceReady) {
      updateMktPrefillEnabledPreference(false);
      updateWebsitePreference(finalUrl);
      updateLanguagePreference(language);
      updateCountryPreference(country);
      setPreferenceReady(true);

      if (afterResetPreferences) {
        afterResetPreferences({
          websiteUrlPreference,
          finalUrl,
          language,
          country,
        });
      }
    }
  }, [preferenceService.setAtUserLevel, country, finalUrl, language, updateCountryPreference, updateLanguagePreference, updateWebsitePreference, preferenceService, updateMktPrefillEnabledPreference, websiteUrlPreference, preferenceReady, afterResetPreferences]);

  return {
    preferenceReady,
  };
};
